import { STORAGE_KEYS } from '../../constants';

export const SESSION_STORAGE_KEYS = {
    TAB_ID: STORAGE_KEYS.TAB_ID,
    TAB_START_TIMESTAMP: STORAGE_KEYS.TAB_START_TIMESTAMP,
} as const;

export type SessionStorageKeyName = keyof typeof SESSION_STORAGE_KEYS;

export interface SessionStorageValueMap {
    TAB_ID: string;
    TAB_START_TIMESTAMP: string;
}

export const SESSION_STORAGE_DEFAULTS: SessionStorageValueMap = {
    TAB_ID: '',
    TAB_START_TIMESTAMP: '0',
};
